<template>
  <div class="home">
    <v-container>
      <!-- TODO 여러 현장 선택해서 비교할 수도 있게 하자 -->
      <!-- TODO IE에서는 v-data-table 깨짐 -->
      <!-- TODO 모터 ON/OFF가 계속 일치할 경우 그래프 y축이 깨진다. 그래프 y축 고정시킬것 -->
      <v-row align="end" justify="end">
        <v-btn large color="black" class="ma-2" text @click="refreshAll">
          <v-icon large>autorenew</v-icon>&nbsp;새로고침&nbsp;
        </v-btn>

        <v-dialog v-model="dialog.dateRangeDialog" width="500">
          <DateRangeDialog :dialog="dialog" :dateRange="dateRange" :selectedSiteStatus="selectedSiteStatus"/>
          <template v-slot:activator="{ on }">
            <v-btn large color="black" class="ma-2" text v-on="on">
              <v-icon large>date_range</v-icon>
              {{ dateRange.rangeText }}
            </v-btn>
          </template>
        </v-dialog>
      </v-row>

      <v-row class="my-n8">
        <v-col>
          <DashboardStatusBar :errorCount="errorCount"
                              :layoutInformation="layoutInformation"
                              :selectedSiteStatus="selectedSiteStatus"
                              :charts="charts"
          />
        </v-col>
      </v-row>

      <v-row v-if="layoutInformation.downGraph" class="my-n8">
        <v-col>
          <GraphDashboard :siteStatus="detailedSiteStatus"
                          :dateRange="dateRange"
                          :selectedSiteStatus="selectedSiteStatus"
                          :layoutInformation="layoutInformation"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col v-if="layoutInformation.leftGraph" cols="3">
          <LeftGraphDashboard  :siteStatus="detailedSiteStatus"
                               :dateRange="dateRange"
                               :selectedSiteStatus="selectedSiteStatus"
                               :layoutInformation="layoutInformation"
          />
        </v-col>
        <v-col :cols="layoutInformation.leftGraph ? 9 : 12">
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  현장목록
                  <v-spacer/>

                  <v-text-field v-model="search" append-icon="search" label="Search"
                                single-line hide-details/>
                  &nbsp;
                  <v-icon class="mt-3" @click="getLatestSiteStatus(false)">refresh</v-icon>
                </v-card-title>
                <v-data-table :headers="headers" :items="latestSiteStatus" :items-per-page="15"
                              :search="search"
                              multi-sort
                              @click:row="refreshSelected"
                              hide-default-footer
                              :page.sync="page"
                              @page-count="pageCount = $event"
                              class="elevation-1 ma-2">
                  <template v-slot:item.hasNoError="{ item }">
                    <td>
                      <div v-if="noDataReceivedRecently(item)">
                        <v-chip class="ma-1" color="orange" text-color="white">
                          <v-icon>warning</v-icon>
                        </v-chip>
                      </div>
                      <div v-else-if="item.hasNoError">
                        <v-chip class="ma-1" color="green" text-color="white">
                          <v-icon>check</v-icon>
                        </v-chip>
                      </div>
                      <div v-else>
                        <v-chip class="ma-1" color="red" text-color="white">
                          <v-icon>error</v-icon>
                        </v-chip>
                      </div>
                    </td>
                  </template>

                  <template v-slot:item.motorStatusContinuesMinutes="{ item }">
                    {{ minutesToText(item.motorStatusContinuesMinutes) }} {{ item.motorRun? '동작중' : '정지중'}}
                  </template>

                  <template v-slot:item.motorRun="{ item }">
                    <v-icon class="mr-2" color="green" v-if="item.motorRun">fas fa-circle-notch fa-spin</v-icon>
                    <v-icon class="mr-2" color="red" v-else>block</v-icon>
                  </template>

                  <template v-slot:item.timestampString="{ item }">
                    {{ printReadableTimestamp(item.timestampString) }}
                  </template>

                  <template v-slot:item.inflowTotal="{ item }">
                    <div class="clickable-cursor" @click.stop="openDialog(item, 'monthlyInflowTotalDialog')">
                      {{ printInflowTotal(item.inflowTotal) }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon class="mr-2 clickable-cursor" @click.native.stop="openDialog(item, 'inspectionDialog')" v-if="higherUserLevel(1)">
                      build
                    </v-icon>
                  </template>
                </v-data-table>
                <v-pagination v-model="page" :length="pageCount" total-visible="5" color="blue-grey darken-2"/>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <SiteStatusHistoryTable :siteStatus="detailedSiteStatus"
                                      :layoutInformation="layoutInformation"
                                      :dateRange="dateRange"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div v-if="dialog.inspectionDialog">
      <SiteInspectionDialog :dialog="dialog" :item="dialogData"/>
    </div>
    <div v-if="dialog.monthlyInflowTotalDialog">
      <MonthlyInflowTotalDialog :dialog="dialog" :item="dialogData"/>
    </div>
  </div>
</template>

<script>
  import '@fortawesome/fontawesome-free/css/all.css'
  import bb from 'billboard.js'

  import axios from 'axios'
  import moment from 'moment'

  import DashboardStatusBar from "../components/dashboard/DashboardStatusBar";
  import GraphDashboard from '../components/dashboard/GraphDashboard'
  import LeftGraphDashboard from "../components/dashboard/LeftGraphDashboard";
  import SiteStatusHistoryTable from "../components/dashboard/SiteStatusHistoryTable";
  import DateRangeDialog from "../components/dashboard/DateRangeDialog";
  import SiteInspectionDialog from "../components/site-inspection/SiteInspectionDialog"
  import MonthlyInflowTotalDialog from "../components/inflow/MonthlyInflowTotalDialog";

  export default {
    name: 'home',
    components: {
      DashboardStatusBar,
      GraphDashboard,
      LeftGraphDashboard,
      SiteStatusHistoryTable,
      DateRangeDialog,
      SiteInspectionDialog,
      MonthlyInflowTotalDialog
    },
    data() {
      return {
        page: 1,
        pageCount: 0,
        layoutInformation: {
          downGraph: true,
          leftGraph: false,
          statusHistoryOpened: false
        },
        refreshTimer: null,
        refreshInterval: {text: '매 5분', value: 60 * 1000 * 5},
        refreshIntervalMenus: [
          {text: '끄기', value: -1},
          {text: '매 1분', value: 60 * 1000},
          {text: '매 3분', value: 60 * 1000 * 3},
          {text: '매 5분', value: 60 * 1000 * 5},
          {text: '매 10분', value: 60 * 1000 * 10},
          {text: '매 30분', value: 60 * 1000 * 30},
          {text: '매 1시간', value: 60 * 1000 * 60},
          {text: '매 4시간', value: 60 * 1000 * 60 * 4},
          {text: '매 12시간', value: 60 * 1000 * 60 * 12},
          {text: '매 24시간', value: 60 * 1000 * 60 * 24},
        ],
        latestSiteStatus: [],
        detailedSiteStatus: [],
        aggregatedSiteStatus: [],
        controlledAggregatedSiteStatus: [],
        siteStatus: [{
          id: '',
          siteId: '',
          name: '',
          waterLevel: 0,
          chemicalLevel: 0,
          hasNoError: true,
          undergroundWaterError: false,
          overloadError: false,
          electricWaveError: false,
          motorRun: true
        }],
        selectedSiteStatus: {
          siteId: '',
          name: '',
          timestamp: 0
        },
        errorCount: {
          total: 0,
          normal: 0,
          error: 0
        },
        dateRange: {
          rangeText: '2019-01-01',
          startDate: '2019-01-01',
          startTime: '00:00:00',
          endDate: '2099-12-31',
          endTime: '00:00:00',
          autoRefreshFunc: null
        },
        charts: {
          down: {},
          left: {}
        },
        search: '',
        headers: [
          {text: '현장상태', value: 'hasNoError', align: 'start', width: "200px"}, // TODO : 이 부분 폼팩터 작아지면 글자 밀리므로 확인...
          //{text: '현장 이름', value: 'name'},
          {text: '주소', value: 'address'},
          {text: '모터동작', value: 'motorRun'},
          {text: '', value: 'motorStatusContinuesMinutes'},
          //{text: '약품 수위', value: 'chemicalLevel'},
          //{text: '일일물량 부족횟수', value: 'todayFloatError'},
          {text: '수위', value: 'waterLevel'},
          //{text: '오늘 유입량', value: 'inflowToday'},
          {text: '누적유량', value: 'inflowTotal'},
          //{text: '현장 ID', value: 'siteId'},
          //{text: '수신시각', value: 'timestampString'},
          //{text: 'CDMA 번호', value: 'cdmaNumber'},
          {text: '설치일자', value: 'installedDate'},
          {text: this.higherUserLevel(1) ? '점검기록' : '', value: 'action', sortable: false}
        ],
        dialogData: {
        },
        dialog: {
          inspectionDialog: false,
          addInspectionDialog: false,
          viewInspectionDialog: false,
          deleteInspectionDialog: false,
          updateInspectionDialog: false,

          monthlyInflowTotalDialog: false,

          dateRangeDialog: false,
        }
      }
    },
    methods: {
      toggleDarkTheme() {
        // TODO : 이거 넣어보면 좋을지도
        this.$vuetify.theme.dark = true;
        // TODO: billboard.js에서는 Nightly version으로 검색
      },
      refreshAll() {
        this.getLatestSiteStatus(false)
          .then(() => {
            const todayPromise = this.getAggregatedSiteStatus(this.selectedSiteStatus, false, 0, 'days');
            const yesterdayPromise = this.getAggregatedSiteStatus(this.selectedSiteStatus, true, 1, 'days');
            const detailedPromise = this.getDetailedSiteStatus(this.selectedSiteStatus);

            return Promise.all([todayPromise, yesterdayPromise, detailedPromise]);
          })
          .then(() => {
            this.generateChart();
          })
      },
      refreshSelected(siteStatus) {
        this.getLatestSiteStatus(false)
          .then(() => {
            const todayPromise = this.getAggregatedSiteStatus(siteStatus, false, 0, 'days');
            const yesterdayPromise = this.getAggregatedSiteStatus(siteStatus, true, 1, 'days');
            const detailedPromise = this.getDetailedSiteStatus(siteStatus);

            return Promise.all([todayPromise, yesterdayPromise, detailedPromise]);
          })
          .then(() => {
            this.generateChart();
          })
      },
      getLatestSiteStatus(loadFirstSiteStatus) {
        // 현장목록 표에 사용할 최근 데이터들을 가져온다.

        const retryFuncBackup = this.getLatestSiteStatus.bind(this, loadFirstSiteStatus);

        // latestSiteStatus라고는 해도 지정된 범위 안에서 latest를 가져오는 것이다.
        // 이 때 dateRange.endTime이 현재 시간보다 뒤쪽이면, 백에서 캐시를 사용할 수 있다.
        const endTimestamp = moment(`${this.dateRange.endDate}T${this.dateRange.endTime}`).valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T${this.dateRange.startTime}`).valueOf();

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteStatus?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        return axios.get(targetUri, config)
          .then(result => {
            this.latestSiteStatus = result.data;

            console.log('latest site status data loaded');
            console.dir(this.latestSiteStatus);

            this.errorCount.total = this.latestSiteStatus.length;
            this.errorCount.normal = this.latestSiteStatus.filter(value => value.hasNoError).length;
            // hasNoError 가 false인 경우를 체크. 그 중에서도 timestamp가 1달 이상 된 경우는 제낀다
            this.errorCount.error = this.latestSiteStatus
              .filter(value => !value.hasNoError)
              .filter(value => value.timestamp > (Date.now() - 2629800000))
              .length;

            //this.errorCount.error = this.errorCount.total - this.errorCount.normal;

            if (loadFirstSiteStatus && this.latestSiteStatus.length > 0) {
              const todayPromise = this.getAggregatedSiteStatus(this.latestSiteStatus[0], false, 0, 'days');
              const yesterdayPromise = this.getAggregatedSiteStatus(this.latestSiteStatus[0], true, 1, 'days');
              const detailedPromise = this.getDetailedSiteStatus(this.latestSiteStatus[0]);

              Promise.all([todayPromise, yesterdayPromise, detailedPromise])
                .then(() => {
                  this.generateChart()
                })
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      getDetailedSiteStatus(siteStatus) {
        // 상세 데이터에 뿌릴 데이터들을 가져온다.

        const retryFuncBackup = this.getDetailedSiteStatus.bind(this, siteStatus);

        // 가장 마지막에 클릭된 site status를 저장해 둔다.
        this.selectedSiteStatus.siteId = siteStatus.siteId;
        this.selectedSiteStatus.name = siteStatus.name;
        this.selectedSiteStatus.timestamp = siteStatus.timestamp;

        const endTimestamp = moment(`${this.dateRange.endDate}T${this.dateRange.endTime}`).valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T${this.dateRange.startTime}`).valueOf();

        console.log(`start:${startTimestamp} end:${endTimestamp}`);

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteStatus/${siteStatus.siteId}/_detailed?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        return axios.get(targetUri, config)
          .then(result => {
            this.detailedSiteStatus = result.data;

            console.log('detailed site status data loaded');
            console.dir(this.detailedSiteStatus);

            if (this.detailedSiteStatus.length === 0) {
              this.popupAlert('해당하는 데이터가 없습니다. 알맞은 시간대로 조정해 주십시오.', 'info');
              return;
            }

            // 표의 데이터도 refresh한다.
            const updatedIndex = this.latestSiteStatus.findIndex(value => {
              // TODO : 이걸 name으로 찾아야 하나? siteId를 쓰지 않는 이유가 있는지
              return value.name === siteStatus.name && value.timestamp < this.detailedSiteStatus[0].timestamp
            });
            if (updatedIndex !== -1) {
              const newLatestSiteStatus = [];
              this.latestSiteStatus.forEach(value => newLatestSiteStatus.push(value));
              newLatestSiteStatus[updatedIndex] = Object.assign({}, this.detailedSiteStatus[0]);
              this.latestSiteStatus = newLatestSiteStatus;
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      getAggregatedSiteStatus(siteStatus, useControlledSiteStatus, subtractAmount, subtractUnit) {
        // 그래프, 혹은 대조군 그래프를 그리기 위해 aggregation된 데이터를 가져온다.
        const retryFuncBackup = this.getAggregatedSiteStatus.bind(this, siteStatus, useControlledSiteStatus, subtractAmount, subtractUnit);

        // yesterday라고는 해도 지정된 범위의 yesterday를 가져오는 것이다.
        const endTimestamp = moment(`${this.dateRange.endDate}T${this.dateRange.endTime}`)
          .subtract(subtractAmount, subtractUnit)
          .valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T${this.dateRange.startTime}`)
          .subtract(subtractAmount, subtractUnit)
          .valueOf();

        console.log(`getAggregatedSiteStatus subtractAmount:${subtractAmount} subtractUnit:${subtractUnit} start:${startTimestamp} yesterday end:${endTimestamp}`);

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteStatus/${siteStatus.siteId}?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        return axios.get(targetUri, config)
          .then(result => {
            console.log('getAggregatedSiteStatus site status data loaded');
            if (useControlledSiteStatus) {
              this.controlledAggregatedSiteStatus = result.data;
              console.dir(this.controlledAggregatedSiteStatus);
            } else {
              this.aggregatedSiteStatus = result.data;
              console.dir(this.aggregatedSiteStatus);
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      generateChart() {
        let graphDirection;
        if (this.layoutInformation.downGraph === true) {
          graphDirection = 'down';
        } else if (this.layoutInformation.leftGraph === true) {
          graphDirection = 'left';
        } else {
          return;
        }

        console.log("generateChart starts!");
        const xAxis = [];
        const waterLevel = [];

        const xAxisYesterday = [];
        const yesterdayWaterLevel = [];

        for (let index = 0; index < this.aggregatedSiteStatus.length; index++) {
          xAxis.unshift(this.extractTime(this.aggregatedSiteStatus[index].timestampString));
          waterLevel.unshift(this.aggregatedSiteStatus[index].waterLevel);
        }

        for (let index = 0; index < this.controlledAggregatedSiteStatus.length; index++) {
          xAxisYesterday.unshift(this.extractTime(this.controlledAggregatedSiteStatus[index].timestampString));
          yesterdayWaterLevel.unshift(this.controlledAggregatedSiteStatus[index].waterLevel);
        }

        let currentWaterLevel;
        if (this.aggregatedSiteStatus.length > 0) {
          //currentWaterLevel = this.aggregatedSiteStatus[0].waterLevel;
          currentWaterLevel = this.latestSiteStatus.filter(value => value.siteId === this.aggregatedSiteStatus[0].siteId)[0].waterLevel
        } else {
          xAxis.unshift('23:59:59.001+09:00');
          xAxis.unshift('00:00:00.001+09:00');
          xAxisYesterday.unshift('23:59:59.001+09:00');
          xAxisYesterday.unshift('00:00:00.001+09:00');
          waterLevel.unshift(0); // 탱크 수위 추이와 약품 수위 추이는 하나씩 빼버리므로 2개를 넣는다.
          currentWaterLevel = 0;
          yesterdayWaterLevel.unshift(0);
        }

        // 현재 탱크 수위
        this.charts[graphDirection].currentTankWaterLevel = bb.generate({
          bindto: `.chartCurrentTankWaterLevel`,
          data: {
            type: "gauge",
            columns: [
              ["현재 탱크 수위", currentWaterLevel]
            ]
          }
        });

        xAxis.unshift('x');
        xAxisYesterday.unshift('x2');

        const todayName = this.dateRange.startDate;
        const yesterdayName = moment(`${this.dateRange.startDate}T${this.dateRange.startTime}`)
          .subtract(1, 'days')
          .format('YYYY-MM-DD');

        waterLevel.unshift(todayName);

        yesterdayWaterLevel.unshift(yesterdayName);

        console.log("waterLevel");
        console.log(xAxis);
        console.log(waterLevel);
        console.log("yesterdayWaterLevel");
        console.log(xAxisYesterday);
        console.log(yesterdayWaterLevel);

        const endTimestamp = moment(`${this.dateRange.endDate}T${this.dateRange.endTime}`).valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T${this.dateRange.startTime}`).valueOf();
        const gap = endTimestamp - startTimestamp;
        let xAxisFormat;
        if (gap < 1000 * 60 * 60 * 72) {
          // 72시간보다 작은 경우
          xAxisFormat = "%H:%M"
        } else if (gap < 1000 * 60 * 60 * 24 * 60) {
          // 60일보다 작은 경우
          xAxisFormat = "%m-%d"
        } else {
          xAxisFormat = "%Y-%m"
        }

        // 물탱크 수위 추이
        const xs = {};
        xs[todayName] = "x";
        xs[yesterdayName] = "x2";

        this.charts[graphDirection].tankWaterLevel = bb.generate({
          bindto: `.chartTankWaterLevel`,
          data: {
            xs: xs,
            xFormat: "%H:%M:%S.%L%Z",
            type: "spline",
            columns: [
              xAxis,
              xAxisYesterday,
              waterLevel,
              yesterdayWaterLevel
            ]
          },
          axis: {
            x: {
              type: "timeseries",
              localtime: true,
              max: `23:59:59.999+09:00`,
              min: `00:00:00.000+09:00`,
              tick: {
                fit: false,
                count: 24,
                format: xAxisFormat
              }
            },
            y: {
              max: 100,
              min: 10,
              tick: {
                outer: false
              }
            }
          }
        });
      },
      minutesToText(minutes) {
        if (minutes < 60) {
          return `${minutes} 분째`;
        }

        const hours = parseInt(minutes / 60);
        const remainMinutes = minutes % 60;

        if (hours < 24) {
          if (remainMinutes === 0) {
            return `${hours} 시간째`;
          }
            return `${hours} 시간 ${remainMinutes} 분째`;
        }

        const days = parseInt(hours / 24);
        const remainHours = hours % 24;
        if (days < 365) {
          if (remainHours === 0) {
            return `${days} 일 이상`;
          } else {
            return `${days} 일 ${remainHours} 시간 이상`;
          }
        }

        const years = parseInt(days / 365);
        const remainDays = days % 365;
        if (remainDays === 0) {
          return `${years} 년 이상`;
        }

        const months = parseInt(remainDays / 30);
        if (months === 0) {
          return `${years} 년 이상`;
        } else {
          return `${years} 년 ${months} 개월 이상`;
        }
      },
      setRange() {
        this.dateRange.rangeText = this.dateRange.startDate;
        this.dateRange.startTime = '00:00:00';
        this.dateRange.endDate = this.dateRange.startDate;
        this.dateRange.endTime = '23:59:59';

        this.dialog.dateRangeDialog = false;
      },
      setDateFromNow(amountDate) {
        const now = moment();
        const startMoment = now.subtract(amountDate, 'days');
        this.dateRange.startDate = startMoment.format('YYYY-MM-DD');
        this.setRange();
      },
      subtractFromNow(amount, unit, rangeText, noRefresh) {
        this.dateRange.autoRefreshFunc = this.subtractFromNow.bind(this, amount, unit, rangeText, noRefresh);

        const now = moment();
        // 현재시간보다 뒤쪽을 endTime으로 지정한다.
        // 백쪽에서 endTimestamp를 확인하고 캐시를 사용할지 여부를 결정할 수 있게 하기 위해서이다.
        now.add(10, 'minutes');
        this.dateRange.endDate = now.format('YYYY-MM-DD');
        this.dateRange.endTime = now.format('HH:mm:ss');
        now.subtract(10, 'minutes');

        // 이 때 now값 자체도 변해버리는듯하니 주의(그러니까 사실은 startMoment로 받지 않아도 된다)
        const startMoment = now.subtract(amount, unit);
        this.dateRange.startDate = startMoment.format('YYYY-MM-DD');
        this.dateRange.startTime = startMoment.format('HH:mm:ss');

        if (rangeText) {
          this.dateRange.rangeText = rangeText;
        }

        // TODO : 여기 아래 필요없는듯
        this.dialog.dateRangeDialog = false;

        if (!noRefresh) {
          this.refreshAll();
        }
      },
      openDialog(item, dialogName) {
        if (!dialogName) {
          this.popupAlert('under construction', 'info');
          return;
        }

        // TODO : 이 부분 테스트는 해볼것
        item.wellPosition = { 'address': item.address };

        this.dialogData = Object.assign({}, item);
        this.dialog[dialogName] = true;
      },
      loadInitialLayout() {
        if ($cookies.isKey('siengLayoutInformation')) {
          this.layoutInformation = $cookies.get('siengLayoutInformation');
        } else {
          this.layoutInformation = {
            downGraph: true,
            leftGraph: false,
            statusHistoryOpened: false
          };
        }
      },
      higherUserLevel(targetUserLevel) {
        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        console.log(`userLevel : ${siengLoginInfoCookie.userLevel}`);
        console.dir(siengLoginInfoCookie);
        return siengLoginInfoCookie.userLevel > targetUserLevel;
      },
      noDataReceivedRecently(latestSiteStatus) {
        // 30분 이상 데이터 미수신으로 판단될시.
        let endTimestamp = moment(`${this.dateRange.endDate}T${this.dateRange.endTime}`).valueOf();
        const now = moment().valueOf();
        if (endTimestamp > now) {
          // 오늘 날짜가 찍혀있는 경우 등에 대비하기 위해서 endTimestamp가 now보다 크면 now로 계산한다.
          endTimestamp = now;
        }
        return latestSiteStatus.timestamp + (1000 * 60 * 30) < endTimestamp
      },
      printReadableTimestamp(timestampString) {
        return timestampString.replace('T', ' ').replace('+09:00', '');
      },
      printInflowTotal(inflowTotal) {
        if (inflowTotal > 655350) {
          // 장비 기본값은 2971878759인 것으로 보인다.
          return 0;
        }

        return inflowTotal / 10 ;
      },
      extractTime(timestampString) {
        return timestampString.split('T')[1];
      },
      clearRefreshInterval() {
        clearInterval(this.refreshTimer);
        console.log('refresh timer cleared.');
      },
      setRefreshInterval(selected) {
        this.refreshInterval = selected;
        this.clearRefreshInterval();

        if (selected.value > 0) {
          this.refreshTimer = setInterval(this.refreshAll, selected.value);
        }

        console.log(`refresh timer set to ${selected.text}`);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
      printDebugLog(target) {
        console.dir(target);
      },
      desktopWidth() {
        return screen.width >= 1024;
      }
    },
    created() {
      this.setRefreshInterval(this.refreshInterval);
    },
    mounted() {
      this.loadInitialLayout();
      this.$bus.$on('refreshGraphs', this.refreshAll);
      //this.subtractFromNow(24, 'hours', '최근 24시간', true);
      this.setDateFromNow(0);
      this.getLatestSiteStatus(true);
    },
    beforeDestroy() {
      this.clearRefreshInterval();
    }
  };
</script>

<style>
  .clickable-cursor {
    cursor: pointer;
  }
</style>